<div class="section-heading" [class.section-heading--center]="align === 'center'">
  @if (eyebrow) {
  <p class="section-heading__eyebrow">{{ eyebrow }}</p>
  }

  <h2 class="section-heading__title"
      [class.section-heading__title--animated]="titleAnimationActive()">{{ title }}</h2>

  @if (text) {
  <p class="section-heading__text">{{ text }}</p>
  }
</div>
